/**
 * Short lesson ideas for the Parents & Teachers page. `pairs` link straight to the lab with the
 * substances picked; `worksheetSlug` links to a printable worksheet from data/worksheets.js.
 */
export const LESSON_IDEAS = Object.freeze([
  {
    title: 'Mixture or new substance?',
    minutes: 20,
    goal: 'Children can explain the difference between a mixture, where things just sit together, and a chemical reaction, which makes something new.',
    activity:
      'Mix iron with sulfur in the lab and read why the result is no longer magnetic. Then mix copper with zinc to make brass, which is a mixture of metals called an alloy. Ask the class to decide which one made a brand-new substance, and how they could tell.',
    pairs: [
      ['Fe', 'S'],
      ['Cu', 'Zn'],
    ],
  },
  {
    title: 'The reactivity race',
    minutes: 25,
    goal: 'Children can predict and then test which metals react with water or acid, and put metals in order from most to least reactive.',
    activity:
      'Hand out the Fizz or No Fizz worksheet. Children predict first, then test each pair in the lab and record what happened. Finish by lining up the metals from the wildest reaction to no reaction at all.',
    worksheetSlug: 'fizz-or-no-fizz',
  },
  {
    title: 'Patterns in the periodic table',
    minutes: 30,
    goal: 'Children can describe how the alkali metals change going down the group, and use the pattern to make a prediction.',
    activity:
      'Use the Alkali Metals in Water worksheet to compare lithium, sodium and potassium. Ask children to predict what rubidium would do before showing them its place in the table.',
    worksheetSlug: 'alkali-metals-in-water',
  },
  {
    title: 'Safety detectives',
    minutes: 15,
    goal: 'Children can explain why some chemicals are only handled by trained scientists, and name three lab safety rules.',
    activity:
      'In small groups, children browse the famous reactions and write down every safety note they find. Each group then designs a lab safety poster with their three most important rules, such as wearing goggles and never tasting chemicals.',
  },
]);
